var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EDF9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 32C47 35.866 43.866 39 40 39C36.134 39 33 35.866 33 32C33 28.134 36.134 25 40 25C43.866 25 47 28.134 47 32ZM46.8829 42.4394C49.0532 43.3897 51.0031 44.7791 52.61 46.5201C52.8536 46.7893 52.992 47.1372 53 47.5001V53.5001C53 53.8979 52.842 54.2794 52.5607 54.5607C52.2794 54.8421 51.8978 55.0001 51.5 55.0001H28.5C28.1056 55.0001 27.7271 54.8448 27.4463 54.5678C27.1656 54.2908 27.0053 53.9144 27 53.5201V47.5201C27.0031 47.1502 27.1419 46.7944 27.39 46.5201C28.9969 44.7791 30.9468 43.3897 33.1171 42.4394C35.2873 41.4891 37.6308 40.9985 40 40.9985C42.3692 40.9985 44.7127 41.4891 46.8829 42.4394Z",
    fill: "#0291D1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/imgPlaceholder.baae34703f3f8e04054e1fb02de1ebaa.svg";
export { ForwardRef as ReactComponent };